module.exports = __webpack_public_path__ + "img/icons8-instagram.304fb315.svg";